import { useEffect, useRef, useState } from 'react'
import { isShadowWorked, setShadowWorked, unSetShadowWorked } from '@/utils/http'
import { onShadowChange } from '@/utils/shadowMode'
import { isProduction } from '@/types/api'

export default function ShadowBall() {
  if (isProduction()) return null
  const [enabled, setEnabled] = useState<boolean>(isShadowWorked())
  const [pos, setPos] = useState<{ x: number; y: number }>(() => {
    const vh = window.innerHeight
    return { x: 16, y: vh - 96 }
  })
  const draggingRef = useRef(false)
  const startRef = useRef<{ sx: number; sy: number; x: number; y: number }>()

  useEffect(() => {
    const off = onShadowChange((e) => setEnabled(e))
    return () => off()
  }, [])

  useEffect(() => {
    const onMove = (e: MouseEvent | TouchEvent) => {
      if (!draggingRef.current) return
      const point = 'touches' in e ? e.touches[0] : (e as MouseEvent)
      const start = startRef.current
      if (!start) return
      const dx = point.clientX - start.sx
      const dy = point.clientY - start.sy
      setPos({ x: Math.max(8, start.x + dx), y: Math.max(8, start.y + dy) })
      e.preventDefault()
    }
    const onUp = () => {
      draggingRef.current = false
    }
    window.addEventListener('mousemove', onMove)
    window.addEventListener('mouseup', onUp)
    window.addEventListener('touchmove', onMove, { passive: false })
    window.addEventListener('touchend', onUp)
    return () => {
      window.removeEventListener('mousemove', onMove)
      window.removeEventListener('mouseup', onUp)
      window.removeEventListener('touchmove', onMove)
      window.removeEventListener('touchend', onUp)
    }
  }, [])

  function handleDown(e: React.MouseEvent | React.TouchEvent) {
    draggingRef.current = true
    const point = 'touches' in e ? e.touches[0] : (e as React.MouseEvent)
    startRef.current = { sx: point.clientX, sy: point.clientY, x: pos.x, y: pos.y }
  }

  function toggleShadow() {
    if (enabled) {
      unSetShadowWorked()
    } else {
      setShadowWorked()
    }
  }

  const size = 48
  const style: React.CSSProperties = {
    position: 'fixed',
    left: pos.x,
    top: pos.y,
    width: size,
    height: size,
    borderRadius: 999,
    background: enabled ? 'rgba(16,185,129,0.9)' : 'rgba(239,68,68,0.9)',
    color: '#fff',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    boxShadow: '0 6px 16px rgba(0,0,0,0.2)',
    userSelect: 'none',
    WebkitUserSelect: 'none',
    cursor: 'grab',
    zIndex: 2147483647,
  }

  return (
    <div
      style={style}
      onMouseDown={handleDown}
      onTouchStart={handleDown}
      onClick={toggleShadow}
      title={enabled ? 'Shadow：开' : 'Shadow：关'}
    >
      {enabled ? 'S-ON' : 'S-OFF'}
    </div>
  )
}


